import { Component, NgZone } from '@angular/core';
import { NavController, NavParams, AlertController } from 'ionic-angular';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { AuthService } from '../../services/auth.service';

import { WalletService } from '../../services/wallet.service';

import { TermsofusePage } from '../termsofuse/termsofuse';
import { PrivacypolicyPage } from '../privacypolicy/privacypolicy';
import { CookiesPage } from '../cookies/cookies';
import { LegalPage } from '../legal/legal';
import { TranslateService } from '@ngx-translate/core';
import { AppUtilities } from '../../app/app.utilities';

@Component({
  selector: 'page-signup-email',
  templateUrl: 'signup-email.html'
})
export class SignupEmailPage {
  signupError: string;
  form: FormGroup;
  terminosUso: boolean = false;
  public termsofusePage = TermsofusePage;
  public privacyPolicy = PrivacypolicyPage;
  public cookies = CookiesPage;
  public legalPage = LegalPage;

  constructor(
    fb: FormBuilder,
    private navCtrl: NavController,
    private auth: AuthService,
    private walletService: WalletService,
    private _translate: TranslateService,
    private ngZone: NgZone,
    public alertCtrl: AlertController,
    private utilities: AppUtilities
  ) {
    this.form = fb.group({
      name: ['', Validators.compose([Validators.required])],
      email: ['', Validators.compose([Validators.required, Validators.email])],
      password: ['', Validators.compose([Validators.required, Validators.minLength(6)])],
      check: ['']
    });
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad SignupPage');
  }

  signup() {
    if (this.terminosUso) {
      this.utilities.loading();
      let data = this.form.value;
      let credentials = {
        email: data.email,
        password: data.password,
        displayName: data.name
      };
      this.auth.signUp(credentials).then(
        response => {
          console.log('User ', response.uid, ' data ', response);
          var address = this.walletService.getAddress();
          var acceptDataProtection = true;
          var urlPhoto = null;

          this.auth.writeUserData(response.uid, data.name, acceptDataProtection, address, urlPhoto);
          this.utilities.loadingDismiss();
        },
        error => {
          this.signupError = error.message;
          this.utilities.loadingDismiss();
        }
      );
    } else {
      var WARNING_TEXT_LOGIN = this._translate.instant('WARNING_TEXT_LOGIN');
      const alert = this.alertCtrl.create({
        subTitle: WARNING_TEXT_LOGIN,
        buttons: ['OK']
      });
      alert.present();
    }
  }

  login_email() {
    this.navCtrl.pop();
  }

  updateValue() {
    console.log('Check box ' + this.terminosUso);
    this.ngZone.run(() => {
      this.terminosUso;
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/signup-email/signup-email.ts